import styles from './Toggle.module.css';

function Toggle({ checked, onChange }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={onChange}
      className={`${styles.track} ${checked ? styles.on : ''}`}
    >
      <span className={styles.thumb} />
    </button>
  );
}

export default Toggle;
